import type { ReactNode } from 'react'
import styles from './EmptyState.module.css'

interface EmptyStateProps {
  title: string
  description?: ReactNode
  /** Optional action, typically a single Button. */
  action?: ReactNode
}

/**
 * A calm placeholder for screens with nothing to show yet. Used while content
 * integration is pending and for genuinely empty collections (e.g. no completed
 * lessons).
 */
export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className={styles.empty}>
      <h2 className={styles.title}>{title}</h2>
      {description ? <p className={styles.description}>{description}</p> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  )
}
